<script setup>
/*
 * Rangliste paa en beregnet spec — billigste kr/TB lige nu.
 *
 * Tallet der rangeres paa staar i KOLONNEN, ikke kun i overskriften.
 * Uden det er en rangliste bare en liste, og laeseren kan ikke se
 * hvorfor nr. 1 er nr. 1.
 */
import { computed } from 'vue';

const props = defineProps({
    data: { type: Object, required: true },
});

const varer = computed(() => props.data.varer || []);

function tal(v) {
    if (v === null || v === undefined) return '';
    return new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: props.data.decimaler ?? 2,
        maximumFractionDigits: props.data.decimaler ?? 2,
    }).format(Number(v));
}

function pris(v) {
    const n = Number(v?.prices?.lowest_price);
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK', maximumFractionDigits: 0 }).format(n);
}

function navn(v) {
    return v.display_name || v.model_short_name || 'Vare';
}
</script>

<template>
    <p v-if="!data.navn" class="text-secondary small mb-0">
        Den valgte enhedspris findes ikke længere.
    </p>

    <p v-else-if="!varer.length" class="text-secondary small mb-0">
        Ingen varer i kategorien har tallet endnu.
    </p>

    <div v-else class="table-responsive">
        <table class="table table-sm align-middle mb-1">
            <thead>
                <tr>
                    <th style="width: 2.5rem">#</th>
                    <th>Vare</th>
                    <th class="text-end">{{ data.navn }}</th>
                    <th class="text-end">Pris</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(v, i) in varer" :key="v.pricecompare_id || i">
                    <td class="text-secondary">{{ i + 1 }}</td>
                    <td>
                        <a :href="v.route_to_productdetail">{{ navn(v) }}</a>
                    </td>
                    <td class="text-end fw-semibold text-nowrap">
                        {{ tal(v.beregnet_vaerdi) }} <span class="text-secondary fw-normal">{{ data.enhed }}</span>
                    </td>
                    <td class="text-end text-nowrap">{{ pris(v) }}</td>
                </tr>
            </tbody>
        </table>
        <p class="small text-secondary mb-0">
            {{ data.lavereErBedre ? 'Lavest' : 'Højest' }} først. Regnet på laveste pris uden fragt,
            fordi fragten varierer med kurven.
        </p>
    </div>
</template>
